"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnsightenConsentManager = void 0;
const Cookies = require("js-cookie");
const consent_manager_1 = require("./consent-manager");
/**
 * Creates a consent manager compatible with the Ensighten Privacy Manager.
 *
 * For determining the current consent it reads the following cookies:
 *  - AUDI_ENSIGHTEN_PRIVACY_Functional
 *  - AUDI_ENSIGHTEN_PRIVACY_Performance
 *  - AUDI_ENSIGHTEN_PRIVACY_Marketing
 *
 * (it is not possible to opt out of essential cookies)
 *
 * The ConsentManager will update the consent when the custom event "ensighten-cookie-consent-change" is fired.
 *
 * @param serverCookies Cookies from the server request supplied on server side. Must not be supplied on client side.
 */
function createEnsightenConsentManager(serverCookies) {
    const getCookie = (name) => (serverCookies ? serverCookies[name] : Cookies.get(name));
    const getConsent = () => ({
        essential: true,
        functional: getCookie('AUDI_ENSIGHTEN_PRIVACY_Functional') === '1',
        performance: getCookie('AUDI_ENSIGHTEN_PRIVACY_Performance') === '1',
        marketing: getCookie('AUDI_ENSIGHTEN_PRIVACY_Marketing') === '1',
    });
    const store = new consent_manager_1.ConsentManager(getConsent);
    if (typeof document !== 'undefined') {
        document.addEventListener('ensighten-cookie-consent-change', () => {
            store.update();
        });
    }
    return store;
}
exports.createEnsightenConsentManager = createEnsightenConsentManager;
//# sourceMappingURL=ensighten-consent-manager.js.map